module.exports = __webpack_public_path__ + "img/slogo.baba0794.png";